// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

const defaultSettings = {
  activeClass: 'is-active',
};

class Search {
  constructor(config) {
    const { el, settings } = config;
    const {
      deleteBtn, form, input, ...settingsWithoutSelectors
    } = settings;

    // Set root element
    this.container = el;
    this.form = el.querySelector(form);
    this.input = el.querySelector(input);
    this.deleteBtn = el.querySelector(deleteBtn);

    // Set settings
    this.settings = { ...defaultSettings, ...settingsWithoutSelectors };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container || !this.deleteBtn || !this.input) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    this.input.addEventListener('input', this.activateBtn);
    this.form.addEventListener('submit', () => this.deleteBtn.removeEventListener('click', this.resetInput));
    this.deleteBtn.addEventListener('click', this.resetInput);
  };

  activateBtn = () => {
    if (this.input.value !== '') {
      this.deleteBtn.classList.add(this.settings.activeClass);
    }
  };

  resetInput = () => {
    this.input.value = '';
    this.deleteBtn.classList.remove(this.settings.activeClass);
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Search);
